import { useState } from 'react';
import { useField } from 'formik';
import { useTheme } from 'styled-components';

import { FormikField } from 'types';
import { Button, addTagConfig, TagButton } from 'common/buttons';

import { TagsModal } from './modal';
import { TagsProps } from './types';
import { Container, ValuesContainer } from './styles';

export const Tags = ({
  label,
  error,
  options,
  onChange,
  values = [],
}: TagsProps) => {
  const theme = useTheme();
  const [visible, setVisible] = useState(false);

  return (
    <Container>
      {label && (
        <p
          style={{
            color: error ? theme.colors.red.main : theme.colors.white.main,
          }}
        >
          {label}
        </p>
      )}
      <ValuesContainer>
        {values.map((value) => (
          <TagButton
            title={value}
            isSelected={true}
            key={`selected-tag-button-${value}`}
            onClick={
              onChange
                ? () => onChange(values.filter((v) => v !== value))
                : undefined
            }
          />
        ))}
        {values.length !== options.length && (
          <Button {...addTagConfig} onClick={() => setVisible(true)} />
        )}
      </ValuesContainer>

      <TagsModal
        options={options}
        visible={visible}
        onChange={onChange}
        selectedValues={values}
        onClose={() => setVisible(false)}
      />
    </Container>
  );
};

export const TagsField = ({ name, ...props }: FormikField<TagsProps>) => {
  const [field, meta, helpers] = useField(name);
  return (
    <Tags
      {...props}
      error={meta.error}
      values={field.value}
      onChange={(updated) => helpers.setValue([...updated])}
    />
  );
};
